import * as Yup from 'yup';
import {LectureFormValues} from './types';
import {TTimetableItem} from '../../../../redux/timetable/timetable.type';

export const initialValueLecture = (lecture?: TTimetableItem | null): Omit<LectureFormValues, 'dayIndex'> => ({
    title: lecture?.title ?? '',
    lecturerIds: lecture?.lecturers?.map(l => l.lid) ?? [],
    tids: lecture?.tickets?.map(t => t.tid) ?? [],
    thid: lecture?.thid ?? null,
    tsid: lecture?.tsid ?? null,
    description: lecture?.description ?? '',
    amount: lecture?.amount ?? 0,
    price: lecture?.price ?? 0,
    hasCasualPrice: lecture?.priceCasual != null,
    priceCasual: lecture?.priceCasual ?? 0,
    isRequired: !!lecture?.isRequired,
    link: lecture?.link ?? '',
    active: !!lecture?.active,
});

export const buildValidationSchema = (requiredMessage: string) =>
    Yup.object({
        title: Yup.string().required(requiredMessage),
        tsid: Yup.number().nullable().required(requiredMessage),
        dayIndex: Yup.number().min(0, requiredMessage).required(requiredMessage),
        amount: Yup.number().min(0),
        price: Yup.number().min(0),
    });
